module.exports = __webpack_public_path__ + "media/src/public/img/saveme_qr_sbp-c8ed7f4e1e8c4d027044bd8ac8691355.png";